<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
    <!-- <ChevronDoubleUp /> -->
  </div>
</template>

<script>
// import ChevronDoubleUp from "vue-material-design-icons/ChevronDoubleUp.vue"

import SvgIcon from '@jamescoyle/vue-icon';
import { mdiChevronDoubleUp } from "@mdi/js"

export default {
  name: "ChevronDoubleUpIcon",
  components: {
    SvgIcon
    // ChevronDoubleUp,
  },
  data() {
    return {
      path: mdiChevronDoubleUp,
    }
  }
}
</script>
